import { combineReducers } from 'redux';
import selectedKey from './selectedKeyReducer';
import openKeys from './openKeysReducer';

export default combineReducers({
  selectedKey,
  openKeys
});
